class GameStatistics {

    constructor() {
        this.userIdOrUsernameInput = null;
        this.gameIdInput = null;
        this.button = null;
        this.iframe = null;

    }

    init() {
        this.userIdOrUsernameInput = document.getElementById('user-id-or-username');
        this.gameIdInput = document.getElementById('game-id');
        this.iframe = document.querySelector('#iframe-container iframe');
        document.getElementById('search-stats-button').onclick = function () {
            this.search()
        }.bind(this);
    }

    search() {

        if (this.userIdOrUsernameInput.value.trim().length === 0) {
            return;
        }

        if (this.gameIdInput.value === '-1') {
            return;
        }

        window.app.ajax.get('/administration/game-statistics/get-iframe-url', {
            'user-id-or-username': this.userIdOrUsernameInput.value,
            'game-id': this.gameIdInput.value
        }, function (response) {
            const statPage = window.open(response.url,"_blank");
            statPage.focus();
            //this.iframe.src = response.url;
        }.bind(this), function(response) {
            window.app.alert.error('Error', response.error);
            this.iframe.src = '';
        }.bind(this));

    }

}
